import '../styles/index.scss';

import './main.js';
import './lazysizes.min.js';
